import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const LOWER = () => {
  return (
    <CardSection id="LOWER" title="LOWER">
      <Paragraph>주어진 텍스트를 모두 소문자로 변환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>LOWER(STRING)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 소문자로 변환할 문자열 또는 열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>LOWER(`School`)</Paragraph>
        <Img src="computeLower" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>STRING</b>은 텍스트 문자열, 텍스트 문자열을 포함하는 열
          또는 텍스트 문자열을 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
